import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = { class: "flex justify-end ml-auto" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "flex search-container" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = {
  key: 0,
  class: "badge border-white text-green-800 bg-green-200 p-4"
}
const _hoisted_9 = {
  key: 1,
  class: "badge border-white text-red-800 bg-red-200 p-4"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)

import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Property from "@/models/product/property/Property";
import { ref, onMounted } from "vue";
import {fetchProperties} from "@/_services/property/property";
import router from "@/router";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomPropertiesList',
  setup(__props) {

const page = ref < number > (1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const properties = Array<Property>();
const tableData = ref<Array<Property>>(properties);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const totalRecords = ref<number>(0);

const editProperty = (propertyUuid: string) => {
  router.push({ name: 'customPropertiesEdit', params: { uuid: propertyUuid } });
};

const listPropertyValue = (propertyUuid: string) => {
    router.push({ name: 'CustomPropertyValuesList', params: { uuid: propertyUuid } });
};

onMounted(async () => {
    await populateDatatable(rows.value, page.value, criteria.value);
});

const populateDatatable = async (itemsPerPage: number, page: number, criteria: string) => {
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchProperties(itemsPerPage, page, criteria);
    totalRecords.value = totalRecordsDt;
    isLoading.value = loadingDt;
    tableData.value = tableDataDt;
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await populateDatatable(e.rows, e.page + 1, criteria.value);
};

const onFilterDt = async () => {
    if (criteria.value != "") {
        await populateDatatable(rows.value, page.value, criteria.value);
    }
};

const onClearInputFilter = async () => {
    if (criteria.value === "") {
        await populateDatatable(rows.value, page.value, "");
    }
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("catalogue.properties.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/properties/create'))),
        label: "Ajouter une propriété",
        icon: "pi pi-plus",
        class: "button-add"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        rows: rows.value,
        paginator: true,
        loading: isLoading.value,
        rowsPerPageOptions: rowsPerPageOptions,
        lazy: "",
        onPage: onPaginate,
        currentPage: currentPage.value,
        totalRecords: totalRecords.value
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createVNode(_unref(InputText), {
                modelValue: criteria.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria).value = $event)),
                onKeyup: _withKeys(onFilterDt, ["enter"]),
                onInput: onClearInputFilter,
                class: "w-64",
                placeholder: "Rechercher une propriété"
              }, null, 8, ["modelValue", "onKeyup"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(Column), {
              field: "name",
              header: "Nom de la propriété",
              class: "whitespace-nowrap"
            }),
            _createVNode(_unref(Column), {
              field: "createdAt",
              header: "Date de création",
              class: "whitespace-nowrap"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.createdAt), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "createdBy.uuid",
              header: "Créé par"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.createdBy), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "status",
              header: "État"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.status)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Actif"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, "Inactif"))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_10
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-eye",
                  class: _normalizeClass(["p-button-success p-button-eye", `${slotProps.data.uuid}`]),
                  style: {"margin-right":"0.5em"},
                  title: "voir les valeurs de propriété",
                  onClick: ($event: any) => (listPropertyValue(slotProps.data.uuid))
                }, null, 8, ["class", "onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "currentPage", "totalRecords"])
    ])
  ], 64))
}
}

})